<template>
  <div class="container mt-4">
    <div class="row">
      <div class="col-12">
        <h3>Güncelleme Notları</h3>
        <div>
          <div v-for="(u, idx) in updates" :key="u.date" class="mb-2">
            <b-card no-body>
              <b-card-header class="py-2" role="button" @click="toggle(idx)">
                <div class="d-flex justify-content-between align-items-center">
                  <div class="fw-bold">{{ u.date }}</div>
                  <div>
                    <small v-if="activeIndex === idx" class="text-muted">Açık</small>
                    <small v-else class="text-muted">Kapalı</small>
                  </div>
                </div>
              </b-card-header>
              <b-collapse :visible="activeIndex === idx">
                <b-card-body>
                  <ul>
                    <li v-for="(n, i) in u.notes" :key="i">{{ n }}</li>
                  </ul>
                </b-card-body>
              </b-collapse>
            </b-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GuncellemeNotlari',
  data() {
    return {
      updates: [],
      activeIndex: 0
    };
  },
  mounted() {
    this.fetchUpdates();
    this.$http.post('/updates/read').catch(() => {});
  },
  methods: {
    toggle(idx) {
      this.activeIndex = (this.activeIndex === idx) ? -1 : idx;
    },
    fetchUpdates(){
      this.$http.get('/updates').then(res=>{ this.updates = res.data || [] }).catch(()=>{ this.updates = [] })
    }
  }
}
</script>

<style scoped>
.card { border: 1px solid #e9ecef; }
</style>
